export default "__VITE_ASSET__8e6ba6e0__"